<template>
  <div class="view-pdf">
    <!-- Spinner -->
    <div style="position: fixed; top: 18%; left: 50%; z-index: 999">
      <looping-rhombuses-spinner
        v-if="loading"
        :animation-duration="speed"
        :rhombus-size="config.size"
        :color="spinnersColor"
      />
    </div>

    <div class="flex xs12">
      <va-card>
        
        <div class="d-flex justify-space-between align-center mb-3">
          <h4 class="va-h4 mb-0">{{ $t('View PDF Report') }}</h4>
          <div>
            <va-button
              icon="fa fa-calendar"
              @click="SetFilter()"
              v-if="!showCalandar"
            >
              Set Filter
            </va-button>

            <va-button
              type="submit"
              id="my-form"
              v-if="showCalandar"
              @click="fetchPdf($event)"
            >
              {{ $t('forms.controls.submit') }}
            </va-button>
          </div>
        </div>

        <!-- Filter Form -->
        <form id="my-form">
          <div class="row flex xs12" v-if="showCalandar">
            <div class="flex xs12 sm6">
              <va-date-picker
                :label="$t('forms.dateTimePicker.from')"
                :config="{
                  locale: { firstDayOfWeek: 1 },
                  inline: false,
                  position: 'below',
                  altInput: true,
                  minDate: SixMonthsAgo,
                  maxDate: today,
                }"
                v-model="datepicker.from"
              />
            </div>

            <div class="flex xs12 sm6">
              <va-date-picker
                :label="$t('forms.dateTimePicker.to')"
                :config="{
                  locale: { firstDayOfWeek: 1 },
                  inline: false,
                  position: 'below',
                  altInput: true,
                  minDate: SixMonthsAgo,
                  maxDate: today,
                }"
                v-model="datepicker.to"
              />
            </div>

            <div class="flex xs12 sm6">
              <va-select
                v-if="isfosa"
                class="mb-4"
                label="Account"
                v-model="datepicker.acc_code"
                textBy="accname"
                :options="accounts"
                key-by="paybill_code"
              />
            </div>
          </div>
        </form>

        <!-- PDF Display -->
        <div class="row flex xs12">
          <object
            v-if="doc"
            :data="documentPath"
            type="application/pdf"
            style="width: 100%; height: 720px; z-index: 998"
          >
            <p>
              It appears you don't have a PDF plugin for this browser.
              <a :href="documentPath" download="document.pdf">
                Click here to download the file.
              </a>
            </p>
          </object>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import * as spinners from "epic-spinners";
export default {
  components: {
    ...spinners,
  },
  name: "view-pdf",
  data() {
    return {
      showCalandar: false,
      loading: false,
      isfosa: false,
      doc: false,
      acc_cd: "",
      acc_details: {},
      accounts: JSON.parse(localStorage.getItem("UserFosas")),
      userData: JSON.parse(localStorage.getItem("LoggedUser")),
      token: JSON.parse(localStorage.getItem("Token")),
      loan_no: "",
      documentPath: "",
      config: {
        size: 38,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      SixMonthsAgo: "",
      today: "",
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
      datepicker: {
        from: "",
        to: "",
        acc_code: "",
      },
      reportCode: "",
    };
  },
  computed: {
    speed() {
      return (
        this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
      );
    },
  },
  methods: {
    getSelected(acc_code) {
      this.fosaacc = acc_code;

      return this.accounts.find(
        (item) => item.paybill_code.toLowerCase() == acc_code.toLowerCase()
      );
    },
    async fetchPdf() {
      this.loading = true;
      const self = this;

      let config = {
        headers: {
          Authorization: this.userData.user_id + " " + this.token,
        },
      };

      if (this.isfosa) {
        this.acc_details = await this.getSelected(
          this.datepicker.acc_code?.paybill_code || "ORD"
        );
        this.acc_cd = this.acc_details.accname;
      }
      const postData = {
        user: this.userData.user_id,
        range: `${this.datepicker.from} to ${this.datepicker.to}`,
        code: this.reportCode,
        loan: this.loan_no,
        acc_code: this.fosaacc,
      };
      axios
        .post(`${this.$apiUrl}ReadPdf`, postData, config)
        .then(function (res) {
          const base64Data = res.data.pdf;

          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          self.documentPath = url;
          self.doc = true;
          self.loading = false;
          self.showCalandar = false;
        })

        .catch(function (error) {
          console.log(error);
        });
    },

    SetFilter() {
      this.showCalandar = true;

      if (this.reportCode == "FOSASTMNT" || this.reportCode == "FOSASTMNTNAV") {
        this.isfosa = true;
      }
    },
  },
  created() {
    this.today = this.$options.filters.dateToYMD(new Date());
    this.datepicker.to = this.today;
    this.SixMonthsAgo = this.$options.filters.createDate(0, -6, -2);
    this.SixMonthsAgo = this.$options.filters.dateToYMD(this.SixMonthsAgo);
    this.datepicker.from = this.SixMonthsAgo;
    let thePath = {};
    thePath = this.$route.fullPath;

    if (this.$route.params.loan_no) {
      this.loan_no = this.$route.params.loan_no;
      this.reportCode = thePath.split("/").slice(-2).reverse().pop();
    } else {
      this.reportCode = thePath.substring(thePath.lastIndexOf("/") + 1);
    }

    if (this.reportCode == "FOSASTMNT" || this.reportCode == "FOSASTMNTNAV") {
      this.isfosa = true;
      this.showCalandar = true;
    } else {
      this.loading = true;
      this.fetchPdf();
    }
  },
};
</script>
